export default __webpack_public_path__ + "static/media/planet.259db76f.png";